import { render, staticRenderFns } from "./menuManage.vue?vue&type=template&id=772e2f0f"
import script from "./menuManage.vue?vue&type=script&lang=js"
export * from "./menuManage.vue?vue&type=script&lang=js"
import style0 from "./menuManage.vue?vue&type=style&index=0&id=772e2f0f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports